module.exports = __webpack_public_path__ + "static/media/Harley.9a3633f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/Harley.png
// module id = 338
// module chunks = 0